import { colorMappingsState } from './colorMappings.js'

const appearances = [
  { background: '#def4e8', border: '#9eddbb', foreground: '#08783f', dot: '#16a564' },
  { background: '#e4efff', border: '#b6d1ff', foreground: '#075dcc', dot: '#1477e6' },
  { background: '#fff0df', border: '#ffd09e', foreground: '#c75b00', dot: '#ee7700' },
  { background: '#f1e4ff', border: '#d7b5ff', foreground: '#7419c8', dot: '#8a2be2' },
  { background: '#ffe7ed', border: '#f8b9c8', foreground: '#ad2345', dot: '#db3e64' },
  { background: '#e0f4f5', border: '#a6dadd', foreground: '#08686e', dot: '#0c8d95' },
]

export const neutralEntityAppearance = Object.freeze({ background: '#F0F2F3', border: '#D3D9DC', foreground: '#37464E', dot: '#7D8990' })

export function appearanceFromColor(color) {
  if (!/^#[0-9a-f]{6}$/i.test(color ?? '')) return neutralEntityAppearance
  const rgb = [1, 3, 5].map((start) => parseInt(color.slice(start, start + 2), 16))
  const tint = (amount) => `#${rgb.map((channel) => Math.round(channel * amount + 255 * (1 - amount)).toString(16).padStart(2, '0')).join('')}`
  // A dark fixed label remains legible even for very light or very dark custom colors.
  return { background: tint(0.12), border: tint(0.38), foreground: '#173A43', dot: color.toUpperCase() }
}

export function entityAppearance(id) {
  const mapping = colorMappingsState.mappings.find((item) => item.entityType === 'FUEL_GRADE' && item.entityId === Number(id))
  return mapping ? appearanceFromColor(mapping.color) : neutralEntityAppearance
}

export function entityAppearanceStyle(id, name = '') {
  const value = entityAppearance(id, name)
  return {
    '--entity-background': value.background,
    '--entity-border': value.border,
    '--entity-foreground': value.foreground,
    '--entity-dot': value.dot,
  }
}

export const defaultEntityAppearances = Object.freeze(appearances.map((item) => Object.freeze({ ...item })))
